export default (setDuplicateData, handleOpen) => (modelcopyFunc, modelId, childId) => {
  setDuplicateData(modelcopyFunc(modelId, childId));
  handleOpen();
};
